import type { FC } from 'react';

import { Youtube } from '../LinkPrompt/vendors/Youtube';

interface LinkEmbedRendererProps {
  service?: string;
  data: Record<string, unknown> | null;
  className?: string;
}

// Shared between the composer's live NodeView and any app rendering a saved
// linkEmbed node (e.g. orchid-v2's community feed/channel/post detail).
export const LinkEmbedRenderer: FC<LinkEmbedRendererProps> = ({ service, data, className }) => {
  if (service === 'youtube') {
    return <Youtube data={data} className={className} />;
  }

  return null;
};
